/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import classNames from 'classnames';
import { debounce, isObject, truncate } from 'lodash';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import ReactPaginate from 'react-paginate';
import Select from 'react-select';
import { toast } from 'react-toastify';
import swal from 'sweetalert';

// UI Components
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import EmailIcon from '@mui/icons-material/Email';
import ImageIcon from '@mui/icons-material/Image';
import PhoneIcon from '@mui/icons-material/Phone';
import SmsIcon from '@mui/icons-material/Sms';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import $ from 'jquery';
import queryString from 'query-string';
// Services
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { hideLoading, showLoading } from '../../../redux/loader/LoaderActions';
import { GET, PATCH, PUT } from '../../../services/rest.service';
// Helpers

const ACTIONS = [
  'Phone - No Answer',
  'Phone - Discussing',
  'Phone - Interested',
  'Phone - Not Interested',
  'Phone - Invalid Number',
  'Phone - Left Message',
  'SMS - Text Sent',
  'SMS - Discussing',
  'SMS - Interested',
  'SMS - Not Interested',
  'Mail - Postcard',
  'Mail - Letter',
  'Email - No Reply',
  'Email - Discussing',
  'Email - Interested',
  'Email - Not Interested',
  'Email - Bounced',
  'None',
];

const LEAD_STATUSES = ['Keen!', 'Warm', 'Cold', 'Test', 'Applicants Sent', 'Interviewing'];

const historyStyles = {
  'Phone - No Answer': 'text-primary',
  'Phone - Discussing': 'text-warning',
  'Phone - Interested': 'text-success',
  'Phone - Not Interested': 'text-danger',
  'Phone - Invalid Number': 'text-danger',
  'Phone - Left Message': 'text-info',
  'SMS - Text Sent': 'text-primary',
  'SMS - Discussing': 'text-warning',
  'SMS - Interested': 'text-success',
  'SMS - Not Interested': 'text-danger',
  'Mail - Postcard': 'text-primary',
  'Mail - Letter': 'text-primary',
  'Email - No Reply': 'text-primary',
  'Email - Discussing': 'text-warning',
  'Email - Interested': 'text-success',
  'Email - Not Interested': 'text-danger',
  'Email - Bounced': 'text-danger',
  None: 'text-primary',
};

const FamilyNannyRequests = () => {
  const dispatch = useDispatch();
  const [records, setRecords] = useState([]);
  const [pages, setPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [historyDialog, setHistoryDialog] = useState(false);
  const [note, setNote] = useState('');
  const [selectedRowId, setSelectedRowId] = useState('');
  const [selectedHistory, setSelectedHistory] = useState([]);
  const [filterAction, setFilterAction] = useState([]);
  const [filterLocation, setFilterLocation] = useState([{ value: 'ALL', label: 'ALL' }]);
  const [filterName, setFilterName] = useState([{ value: 'ALL', label: 'ALL' }]);
  const [filterStatus, setFilterStatus] = useState([]);
  const [leadStatus, setLeadStatus] = useState('');
  const [action, setAction] = useState('');
  const [location, setLocation] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [isSearchingEmail, setIsSearchingEmail] = useState(false);
  const [isSearchingPhone, setIsSearchingPhone] = useState(false);
  const [isClearable, setIsClearable] = useState(true);
  const [selectedOptionNames, setSelectedOptionNames] = useState(null);
  const [selectedOptionLocations, setSelectedOptionLocations] = useState(null);
  const navigate = useNavigate();
  const prevLocationRef = useRef(window.location.search);

  useEffect(() => {
    let { page } = queryString.parse(window.location.search);

    if (page) {
      getPage(page);
    } else {
      getPage(1);
    }

    getFilterData();

    $(function () {
      $('.scroll-main').on('scroll', function () {
        $('.scroll-child').scrollLeft($('.scroll-main').scrollLeft());
      });
      $('.scroll-child').on('scroll', function () {
        $('.scroll-main').scrollLeft($('.scroll-child').scrollLeft());
      });
    });
  }, []);

  useEffect(() => {
    if (prevLocationRef.current !== window.location.search) {
      let { page } = queryString.parse(window.location.search);
      if (page) {
        getPage(page);
      } else {
        getPage(1);
      }
      prevLocationRef.current = window.location.search;
    }
  }, [window.location.search]);

  const getFilterData = async () => {
    try {
      const res = await GET(`/admin/families/getFilters`);
      let locationdata = res.data.locations.map((x) => {
        return {
          value: x,
          label: x,
        };
      });
      let namedata = res.data.names.map((x) => {
        return {
          value: x,
          label: x,
        };
      });
      setFilterAction(res.data.action);
      setFilterLocation(filterLocation.concat(locationdata));
      setFilterName(filterName.concat(namedata));
      setFilterStatus(res.data.leadStatus);
    } catch (err) {
      console.error(err);
    }
  };

  const handlePageClick = (e) => {
    const parsed = queryString.parse(window.location.search);
    parsed.page = e.selected + 1;

    navigate({
      pathname: `/admin/family/list`,
      search: queryString.stringify(parsed),
    });
  };

  const getPage = async (page) => {
    let { name, location, email, phone, status, action } = queryString.parse(window.location.search);
    dispatch(showLoading());
    try {
      const { data } = await GET(
        `/admin/families/getAll/${page}?limit=${10}&name=${name || ''}&email=${email || ''}&location=${location || ''}&mobile_number=${phone || ''}&lead_status=${
          status || ''
        }&action=${action || ''}`,
      );
      setName(name);
      setLocation(location);
      setEmail(email);
      setPhone(phone);
      setLeadStatus(status);
      setAction(action);
      setRecords(data.Requests);
      setPages(data.Pages);
      setTotal(data.Total);
      setCurrentPage(page);
      setIsSearchingEmail(false);
      setIsSearchingPhone(false);
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.message);
    }
  };

  const onStatusChange = async (value, _id) => {
    const payload = {
      _id,
      type: 'lead_status',
      value,
    };

    try {
      await PUT('/admin/family/requests/update', payload);
      getPage(currentPage);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleNotes = (_id) => {
    setNote('');
    setSelectedRowId(_id);
    handleDialogClose();
  };

  const handleDialogClose = () => {
    setOpen(!open);
  };

  const handleHistoryDialogClose = (history) => {
    setHistoryDialog(!historyDialog);
    setSelectedHistory(history);
  };

  const handleDeleteRecord = async (record) => {
    const index = records.findIndex((x) => x._id === record._id);

    try {
      const result = await swal({
        title: 'Are you sure?',
        text: 'Are you sure you want to delete this family account? All their data will be lost forever.',
        icon: 'warning',
        buttons: ['No', 'Yes'],
      });
      if (result) {
        await PATCH(`/admin/user/change_status/${record._id}`, { status: 'Deleted' });
        setRecords([...records.slice(0, index), ...records.slice(index + 1)]);
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const closeHistoryDialog = () => {
    setHistoryDialog(!historyDialog);
    setSelectedHistory([]);
  };

  const handleTextChange = (e) => {
    setNote(e.target.value);
  };

  const handleEditNote = (note, _id) => {
    setNote(note);
    setSelectedRowId(_id);
    handleDialogClose();
  };

  const handleNoteAdd = async () => {
    const payload = {
      _id: selectedRowId,
      type: 'note',
      value: note,
    };

    try {
      await PUT('/admin/family/requests/update', payload);
      getPage(currentPage);
      handleDialogClose();
    } catch (err) {
      toast.error(err.message);
    }
  };

  const onActionChange = async (value, _id) => {
    const payload = {
      _id,
      type: 'action',
      value,
    };

    try {
      await PUT('/admin/family/requests/update', payload);
      getPage(currentPage);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const createRecord = () => {
    navigate(`/admin/family/create`);
  };

  const renderSwitch = (param) => {
    if (param.indexOf('Phone') > -1) {
      return <PhoneIcon className={historyStyles[param]} />;
    } else if (param.indexOf('SMS') > -1) {
      return <SmsIcon className={historyStyles[param]} />;
    } else if (param.indexOf('Email') > -1 || param.indexOf('Mail') > -1) {
      return <EmailIcon className={historyStyles[param]} />;
    } else {
      return <ImageIcon className={historyStyles[param]} />;
    }
  };

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
    setIsSearchingEmail(true);
  };

  const handleChangePhone = (e) => {
    setPhone(e.target.value);
    setIsSearchingPhone(true);
  };

  const handleOnChangeLocation = (selectedOptionLocations) => {
    if (isObject(selectedOptionLocations)) {
      setSelectedOptionLocations(selectedOptionLocations);
      setLocation(selectedOptionLocations.value === 'ALL' ? '' : selectedOptionLocations.value);
    } else {
      setLocation('');
      setSelectedOptionLocations(null);
    }
  };

  const handleOnChangeName = (selectedOptionNames) => {
    if (isObject(selectedOptionNames)) {
      setSelectedOptionNames(selectedOptionNames);
      setName(selectedOptionNames.value === 'ALL' ? '' : selectedOptionNames.value);
    } else {
      setName('');
      setSelectedOptionNames(null);
    }
  };

  useEffect(() => {
    const searchParams = {
      page: currentPage,
      name: name || '',
      location: location || '',
      email: email || '',
      phone: phone || '',
      action: action || '',
      status: leadStatus || '',
    };

    Object.keys(searchParams).forEach((key) => searchParams[key] === '' && delete searchParams[key]);

    const searchString = queryString.stringify(searchParams);

    const searchHandler = () => {
      navigate({
        pathname: `/admin/family/list`,
        search: searchString,
      });
    };

    const debouncedSearch = debounce(searchHandler, 1000);

    if (location !== '' || name || email || phone || action || leadStatus) {
      debouncedSearch();
    }

    return () => {
      debouncedSearch.cancel();
    };
  }, [name, location, email, phone, action, leadStatus]);

  return (
    <React.Fragment>
      <div className="container-fluid px-xl-5">
        <section className="py-5">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h6 className="text-uppercase mb-0">Family Nanny Requests</h6>
                  <Button variant="outlined" color="secondary" sx={{ margin: 0, padding: '5px' }} onClick={createRecord}>
                    Create
                  </Button>
                </div>
                <div className="card-body">
                  <div className="">
                    <div className="row">
                      <div className="col-12 col-md-6 col-lg-3 form-group">
                        <Select value={selectedOptionNames} isClearable={isClearable} placeholder="Select Name" options={filterName} onChange={handleOnChangeName} />
                      </div>
                      <div className="col-12 col-md-6 col-lg-3 form-group">
                        <div className="input-group searchbar">
                          <span className="ic-search">
                            <i className={`fa ${isSearchingEmail ? 'fas fa-spinner fa-spin' : 'fa-search'}`} />
                          </span>
                          <input type="text" name="Search-Email" className="form-control" value={email} placeholder="Search by Email" onChange={handleChangeEmail} />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-3 form-group">
                        <Select
                          value={selectedOptionLocations}
                          isClearable={isClearable}
                          placeholder="Select Location"
                          options={filterLocation}
                          onChange={handleOnChangeLocation}
                        />
                      </div>
                      <div className="col-12 col-md-6 col-lg-3 form-group">
                        <div className="input-group searchbar">
                          <span className="ic-search">
                            <i className={`fa ${isSearchingPhone ? 'fas fa-spinner fa-spin' : 'fa-search'}`} />
                          </span>
                          <input type="text" name="Search-Phone No" className="form-control" value={phone} placeholder="Search by Phone" onChange={handleChangePhone} />
                        </div>
                      </div>

                      <div className="col-12 col-md-6 col-lg-3 form-group">
                        <select
                          id="lead_status"
                          value={leadStatus}
                          required
                          className="form-control mr-2"
                          onChange={(e) => {
                            setLeadStatus(e.target.value);
                          }}
                        >
                          <option value={''}>--Select Status--</option>
                          {filterStatus.map(
                            (x, index) =>
                              x && (
                                <option value={x} key={index}>
                                  {x}
                                </option>
                              ),
                          )}
                        </select>
                      </div>
                      <div className="col-12 col-md-6 col-lg-3 form-group">
                        <select
                          id="action"
                          value={action}
                          required
                          className="form-control mr-2"
                          onChange={(e) => {
                            setAction(e.target.value);
                          }}
                        >
                          <option value={''}>--Select Action--</option>
                          {filterAction.map(
                            (x, index) =>
                              x && (
                                <option value={x} key={index}>
                                  {x}
                                </option>
                              ),
                          )}
                        </select>
                      </div>
                      <div className="col-12 col-md-6 col-lg-3 form-group">
                        <Button
                          variant="outlined"
                          color="secondary"
                          sx={{ margin: 0, padding: '5px' }}
                          onClick={() => {
                            setLeadStatus('');
                            setAction('');
                            setLocation('');
                            setName('');
                            setEmail('');
                            setPhone('');
                            setIsClearable(true);
                            setSelectedOptionNames(null);
                            setSelectedOptionLocations(null);
                          }}
                        >
                          Reset Filter
                        </Button>
                      </div>
                    </div>
                  </div>

                  <div className={'table-responsive table-scroll'}>
                    <div className="scroll-main">
                      <div className="scroll-main-inner"></div>
                    </div>
                    <div className="scroll-child">
                      <table className="table card-text scroll-child-inner">
                        <thead>
                          <tr>
                            <th>&nbsp;</th>
                            <th>Date Signed Up</th>
                            <th>Status</th>
                            <th>Action</th>
                            <th>Last Action Date</th>
                            <th>Family Name</th>
                            <th>Email</th>
                            <th>Family Location</th>
                            <th>Phone Number</th>
                            <th>Preferred Contact Method</th>
                            {/* <th>Nanny Request Date</th>
                            <th>Nanny Availability</th>
                            <th>Nanny Location</th> */}
                            <th>Notes</th>
                            <th className={'text-center'}>#</th>
                          </tr>
                        </thead>
                        <tbody className="tr-loop">
                          {records.map((record) => (
                            <TableRow
                              key={record._id}
                              record={record}
                              histories={selectedHistory}
                              onStatusChange={onStatusChange}
                              onNoteAdd={handleNotes}
                              onEditNote={handleEditNote}
                              onHistoryDialogOpen={handleHistoryDialogClose}
                              onDeleteRecord={handleDeleteRecord}
                              onActionChange={onActionChange}
                            />
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mx-auto my-4">
              <ReactPaginate
                previousLabel={'previous'}
                nextLabel={'next'}
                breakLabel={'...'}
                breakClassName={'break-me'}
                pageCount={pages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                containerClassName={'pagination'}
                subContainerClassName={'pages pagination'}
                activeClassName={'active'}
                pageLinkClassName={'page-link'}
                previousClassName={'page-item'}
                nextClassName={'page-item'}
                previousLinkClassName={'page-link'}
                nextLinkClassName={'page-link'}
                pageClassName={'page-item'}
                onPageChange={handlePageClick}
              />
            </div>
          </div>
        </section>
      </div>
      <Dialog open={open} onClose={handleDialogClose} maxWidth={'md'} fullWidth={true} disableBackdropClick={true} aria-labelledby="form-dialog-title">
        <DialogTitle id="max-width-dialog-title">User Notes</DialogTitle>
        <DialogContent>
          <TextField autoFocus margin="dense" id="note" label="Note" type="text" multiline value={note} onChange={handleTextChange} fullWidth={true} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleNoteAdd} color="primary">
            Add
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={historyDialog} onClose={handleHistoryDialogClose} maxWidth={'xs'} fullWidth={true} disableBackdropClick={true} aria-labelledby="form-dialog-title">
        <DialogTitle id="max-width-dialog-title">Action History</DialogTitle>
        <DialogContent>
          <List>
            {selectedHistory.map((item, index) => {
              return (
                <ListItem>
                  <ListItemAvatar>
                    <Avatar className={'bg-light'}>{renderSwitch(item.type)}</Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={item.type} secondary={moment(item.created_at).format('MM/DD/YYYY HH:mm A')} />
                </ListItem>
              );
            })}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeHistoryDialog} color="primary">
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

const LeadStatusSelectBox = ({ value, id, onStatusChange }) => {
  const [visible, setVisibility] = useState(false);
  const toggleDropDown = classNames('btn-group');
  const dropDownMenu = classNames('dropdown-menu');
  const button = classNames(
    'btn dropdown-toggle',
    { 'btn-success': value === 'Keen!' },
    { 'btn-darkblue': value === 'Interviewing' },
    { 'btn-lightblue': value === 'Applicants Sent' },
    { 'btn-warning': value === 'Warm' },
    { 'btn-info': value === 'Cold' },
    { 'btn-danger': value === 'Test' },
    { 'btn-default': value === 'None' },
  );

  return (
    <div className={toggleDropDown}>
      <button type="button" className={button} onClick={() => setVisibility(!visible)} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        {value}
      </button>
      <div className={dropDownMenu}>
        {LEAD_STATUSES.map((status, index) => (
          <a href="#!" className={'dropdown-item'} key={index} onClick={() => onStatusChange(status, id)}>
            {status}
          </a>
        ))}
      </div>
    </div>
  );
};

const StatusSelectBox = ({ value, id, onActionChange }) => {
  const [visible, setVisibility] = useState(false);
  const toggleDropDown = classNames('btn-group min-h-300');
  const dropDownMenu = classNames('dropdown-menu');
  const button = classNames(
    'btn dropdown-toggle',
    { 'btn-primary': value === 'Phone - No Answer' },
    { 'btn-warning': value === 'Phone - Discussing' },
    { 'btn-success': value === 'Phone - Interested' },
    { 'btn-danger': value === 'Phone - Not Interested' },
    { 'btn-danger': value === 'Phone - Invalid Number' },
    { 'btn-info': value === 'Phone - Left Message' },
    { 'btn-primary': value === 'SMS - Text Sent' },
    { 'btn-warning': value === 'SMS - Discussing' },
    { 'btn-success': value === 'SMS - Interested' },
    { 'btn-danger': value === 'SMS - Not Interested' },
    { 'btn-primary': value === 'Mail - Postcard' },
    { 'btn-primary': value === 'Mail - Letter' },
    { 'btn-primary': value === 'Email - No Reply' },
    { 'btn-warning': value === 'Email - Discussing' },
    { 'btn-success': value === 'Email - Interested' },
    { 'btn-danger': value === 'Email - Not Interested' },
    { 'btn-danger': value === 'Email - Bounced' },
    { 'btn-secondary': value === 'None' },
  );

  return (
    <div className={toggleDropDown}>
      <button type="button" className={button} onClick={() => setVisibility(!visible)} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        {value}
      </button>
      <div className={dropDownMenu} aria-labelledby="dropdownMenuButton">
        {ACTIONS.map((status, index) => (
          <a href="#!" className={'dropdown-item'} key={index} onClick={() => onActionChange(status, id)}>
            {status}
          </a>
        ))}
      </div>
    </div>
  );
};

const TableRow = ({ record, onStatusChange, onActionChange, onNoteAdd, onEditNote, onHistoryDialogOpen, onDeleteRecord }) => {
  const [visible, setVisibility] = useState(false);
  const navigate = useNavigate();
  const toggleRow = classNames({ 'show-detail': visible });
  const toggleIcon = classNames('c-pointer fas', { 'fa-minus-circle': visible }, { 'fa-plus-circle': !visible });
  const NoteContent = (
    <Tooltip title={'Click to edit the note'} placement={'bottom'}>
      <span className="c-pointer text-primary" onClick={() => onEditNote(record.note, record._id)}>
        {truncate(record.note, {
          length: 30,
          omission: '...',
        })}
      </span>
    </Tooltip>
  );

  return (
    <React.Fragment>
      <tr className={'toggle-row'}>
        <td>{record.requests.length !== 0 && <i className={toggleIcon} onClick={() => setVisibility(!visible)} />}</td>
        <td onClick={() => navigate(`/admin/family/view/${record._id}`)} className="c-pointer text-primary">
          {moment(record.created_at?.substring(0, 10)).format('MM/DD/YYYY')}
        </td>
        <td>
          <LeadStatusSelectBox value={record.lead_status} id={record._id} onStatusChange={onStatusChange} />
        </td>
        <td>
          <StatusSelectBox value={record.action} id={record._id} onActionChange={onActionChange} />
        </td>
        <td>
          {record.lead_action_history.length > 0 && (
            <Tooltip title="Click to view all" placement="bottom">
              <span className="c-pointer text-primary" onClick={() => onHistoryDialogOpen(record.lead_action_history)}>
                {moment(record.lead_action_history[0].created_at).format('MM/DD/YYYY HH:mm A')}
              </span>
            </Tooltip>
          )}
        </td>
        <td>
          {record.first_name}&nbsp;{record.last_name}
        </td>
        <td>{record.email}</td>
        <td>{record.location.address}</td>
        <td>{record.mobile_number}</td>
        <td>{record.preferredContactMethod ? record.preferredContactMethod.replace(/_/g, ' ') : 'N/A'}</td>

        {/* <td>{record.requests.length > 0 && moment(record.requests[0].created_at).format('MM/DD/YYYY HH:mm A')}</td>
          <td>{get(record, 'requests[0].availability', '')}</td>
          <td>{get(record, 'requests[0].place_of_work.address', '')}</td> */}
        <td>
          {record.note ? (
            NoteContent
          ) : (
            <span className="c-pointer text-primary" onClick={() => onNoteAdd(record._id)}>
              Add Note
            </span>
          )}
        </td>
        <td>
          <IconButton color="secondary" sx={{ margin: 0, padding: '5px' }} onClick={() => navigate(`/admin/family/view/${record._id}`)}>
            <VisibilityIcon />
          </IconButton>
          <IconButton color="primary" sx={{ margin: 0, padding: '5px' }} onClick={() => navigate(`/admin/family/update/${record._id}`)}>
            <EditIcon />
          </IconButton>
          <IconButton color="secondary" sx={{ margin: 0, padding: '5px' }} onClick={() => onDeleteRecord(record)}>
            <DeleteIcon />
          </IconButton>
        </td>
      </tr>
      <tr className={toggleRow}>
        <td className="p-0" colSpan="1"></td>
        <td className="p-0" colSpan="10">
          {record.requests.length === 0 ? (
            <p>data not available</p>
          ) : (
            <table className="table mb-0 no-border-first-row bg-light-grey">
              <thead>
                <tr>
                  <th>Nanny Requested Date</th>
                  <th>Start Date</th>
                  <th>Nanny Availability</th>
                  <th>Nanny Location</th>
                  <th>Number of children</th>
                  <th>Children's Age</th>
                  <th>Transport Children Type</th>
                  <th>Status</th>
                  <th>Requested Skills</th>
                </tr>
              </thead>
              <tbody>
                {record.requests.map((request) => {
                  return (
                    <tr key={request._id}>
                      <td>{moment(request.created_at.substring(0, 10)).format('MM/DD/YYYY')}</td>
                      <td>{moment(request.start_date.substring(0, 10)).format('MM/DD/YYYY')}</td>
                      <td>{request.availability}</td>
                      <td>{request.place_of_work ? request.place_of_work.address : '-'}</td>
                      <td>{request.no_of_children}</td>
                      <td>{request.children_age}</td>
                      <td>{request.transport_children}</td>
                      <td>{request.status}</td>
                      <td>{request.skills.map((skill) => skill.title).join(', ')}</td>
                      <td></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </td>
      </tr>
    </React.Fragment>
  );
};

export default FamilyNannyRequests;
